// extracted by mini-css-extract-plugin
module.exports = {"root":"_2rsTN","deleteMessageWarning":"_141Tv","infoIcon":"_1_3N6"};